<template>
  <div id="navBarTouch">
    <div
      :class="{ selected: !mapViewSelected}"
      @click="setMapViewSelected(false)"
    >
      <ListViewIcon :iconColor="!mapViewSelected ? '#ffffff' :'#7A81B0' " />
    </div>
    <div
      :class="{ selected: mapViewSelected}"
      @click="setMapViewSelected(true)"
    >
      <MapViewIcon :iconColor="mapViewSelected ? '#ffffff' :'#7A81B0' " />
    </div>
  </div>
</template>

<script>
import MapViewIcon from '@/components/Icons/MapView';
import ListViewIcon from '@/components/Icons/ListView';
export default {
  name: 'nav-touch',
  components: { MapViewIcon, ListViewIcon },
  props: {
    mapViewSelected: Boolean,
    setMapViewSelected: Function,
  },
};
</script>

<style lang="scss" scoped>
#navBarTouch {
  display: none;
}

@media only screen and (max-width: $tablet-landscape-max-width) {
  #navBarTouch {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: fixed;
    top: 122px;
    padding-top: 20px;
    right: 0;
    bottom: 0;
    width: 90px;
    background: #060f4b;
    box-shadow: inset 5px 5px 10px 0 rgba(0, 0, 0, 0.3);
    z-index: 10;
    div {
      width: 100%;
      padding: 20px 0;
      cursor: pointer;
      position: relative;
    }
  }

  #navBarTouch div.selected:before {
    content: '';
    position: absolute;
    left: 0;
    top: 24px;
    top: calc(50% - 12px);
    border: 12px solid transparent;
    border-left-color: #e4e6f0;
    z-index: 3;
  }

  #navBarTouch div svg {
    display: block;
    margin: auto;
  }
}
@media only screen and (max-width: $mobile-max-width) {
  #navBarTouch {
    top: auto;
    flex-direction: row;
    justify-content: center;
    right: auto;
    left: 0;
    width: 100%;
    height: 70px;
    padding-top: 0;
    div {
      width: 80px;
      padding: 18px;
      height: 100%;
      &:first-child {
        padding: 22px 18px;
      }
    }
  }
  #navBarTouch div.selected:before {
    content: '';
    position: absolute;
    left: 24px;
    left: calc(50% - 12px);
    top: 0;
    border-left-color: transparent;
    border-top-color: #e4e6f0;
  }
}
</style>
